import axios from '@/utils/axios';
import { messages } from '@/utils';
import * as types from '../mutations-types';

const updateStorage = cart => {
    const c = localStorage.getItem('_cart');
    if (c !== cart) {
        localStorage.setItem('_cart', JSON.stringify(cart));
    }
};

const state = {
    loading: false,
    products: [],
    product: {},
    ofertas: [],
    cart: [] // [{product:{}, cantidad: x}]
};

const getters = {
    cartCount: state => state.cart.length
};

const mutations = {
    [types.LOADING](state, value) {
        state.loading = typeof value !== 'undefined' ? value : true;
    },
    [types.SET_PRODUCTS](state, products) {
        state.products = products;
    },
    [types.SET_PRODUCT](state, product) {
        state.product = product;
    },
    [types.SET_OFERTAS](state, ofertas) {
        state.ofertas = ofertas;
    },
    [types.SET_CART](state, cart) {
        state.cart = cart;
        updateStorage(state.cart);
    },
    [types.CLEAR_CART](state) {
        state.cart = [];
        localStorage.removeItem('_cart');
    },
    [types.ADDTOCART]({ cart }, item) {
        const prodExistente = cart.find(
            ({ product }) => product.id === item.product.id
        );
        if (!prodExistente) {
            cart.push(item);
        } else {
            prodExistente.cantidad += item.cantidad;
        }
        updateStorage(cart);
    },
    [types.REMOVEFROMCART](state, item) {
        state.cart = state.cart.filter(({ product }) => product !== item);
        updateStorage(state.cart);
    },
    [types.SET_CANTIDAD](state, { item, cant }) {
        if (cant < 1) {
            return;
        }
        state.cart = state.cart.map(cartItem =>
            cartItem.product.id === item.product.id
                ? {
                      ...cartItem,
                      cantidad: cant
                  }
                : cartItem
        );
        updateStorage(state.cart);
    },
    [types.AUMENTAR_CANTIDAD](state, item) {
        state.cart = state.cart.map(cartItem =>
            cartItem.product.id === item.product.id
                ? {
                      ...cartItem,
                      cantidad: cartItem.cantidad + 1
                  }
                : cartItem
        );
        updateStorage(state.cart);
    },
    [types.DISMINUIR_CANTIDAD](state, item) {
        state.cart = state.cart.map(cartItem =>
            cartItem.product._id === item.product._id
                ? {
                      ...cartItem,
                      cantidad: cartItem.cantidad - 1
                  }
                : cartItem
        );
        updateStorage(state.cart);
    }
};

const actions = {
    getCartFromStorage({ commit }) {
        const cart = JSON.parse(localStorage.getItem('_cart'));
        if (cart) {
            commit(types.SET_CART, cart);
        }
    },
    async getProducts(
        { commit },
        {
            search = '',
            page = 1,
            productsPerPage = 12,
            labs = [],
            sales = false,
            withPrices = true
        }
    ) {
        try {
            const take = productsPerPage;
            commit(types.LOADING);
            const { status, data } = await axios.get('/products', {
                params: {
                    skip: (page - 1) * take,
                    take,
                    search,
                    labs,
                    sales,
                    withPrices
                }
            });
            const products = data.data;
            if (status === 200) {
                if (sales) {
                    commit(types.SET_OFERTAS, products);
                } else {
                    commit(types.SET_PRODUCTS, products);
                }
            }
            return { data: products };
        } catch ({ status, error }) {
            return {
                error:
                    status === 403 ? 'Debe iniciar Sesión.' : messages.api.error
            };
        } finally {
            commit(types.LOADING, false);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
